import { IKDSPageState } from '../models/kdsPage.interface';
import { SET_IS_KDS_PAGE, SET_PAGE_NAME } from '../actions/kdsPage.action';

const initialVideoPageState: IKDSPageState = {
	isKDSPage: false,
	pageName: '',
};

const kdsPageReducer = (
	state: IKDSPageState = initialVideoPageState,
	action: {
		type: string;
		payload: Partial<IKDSPageState>;
	}
): IKDSPageState => {
	switch (action.type) {
		case SET_IS_KDS_PAGE:
			return { ...state, isKDSPage: !!action.payload.isKDSPage };
		case SET_PAGE_NAME:
			return { ...state, pageName: action.payload.pageName || '' };
		default:
			return state;
	}
};

export default kdsPageReducer;
